import { OPEN_MODAL } from '@storeOld/actions'
import { takeEvery } from 'redux-saga/effects'

import { AuthActions } from '../actions'
import { authModalOpen } from './authModalOpen'
import { logout } from './logout'
import { setTokenSaga } from './setToken'

export function* authSaga() {
  yield takeEvery(AuthActions.logout, logout)
  yield takeEvery(AuthActions.setToken, setTokenSaga)
  yield takeEvery(OPEN_MODAL, authModalOpen)
}
